import { fetchSupportBrandsApi, createTicketApi, fetchTicketFieldsApi, fetchTicketCreationFieldsApi } from "../../api/Header";
import { createTicket, getSupportBrands, getTicketFields, getTicketCreationFields } from "../../api/urls";
import { CONSTANTS, NO_OP } from "../../constants/Constants";
import { notificationHelper } from "../../utils/helper";
const {
  ACTIONS
} = CONSTANTS;
export const fetchSupportBrands = baseUrl => dispatch => {
  const url = "".concat(baseUrl).concat(getSupportBrands);
  dispatch({
    type: ACTIONS.SET_TICKET_LOADER,
    payload: {
      supportBrands: true
    }
  });
  return fetchSupportBrandsApi(url).then(_ref => {
    let {
      brands
    } = _ref;
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        supportBrands: false
      }
    });
    dispatch({
      type: ACTIONS.SET_TICKET_DRAWER_API,
      payload: false
    });
    dispatch({
      type: ACTIONS.SET_SUPPORT_BRANDS,
      payload: brands
    });
  }).catch(() => {
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        supportBrands: false
      }
    });
    dispatch({
      type: ACTIONS.SET_TICKET_DRAWER_API,
      payload: true
    });
    dispatch({
      type: ACTIONS.SET_SUPPORT_BRANDS,
      payload: []
    });
    notificationHelper('error', __('Failed to fetch Support Brands'), ' ', 5, NO_OP, '');
  });
};
export const fetchTicketFields = (baseUrl, formId) => dispatch => {
  const url = "".concat(baseUrl).concat(getTicketFields.replace('{formId}', formId));
  dispatch({
    type: ACTIONS.SET_TICKET_LOADER,
    payload: {
      ticketFields: true
    }
  });
  return fetchTicketFieldsApi(url).then(res => {
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        ticketFields: false
      }
    });
    dispatch({
      type: ACTIONS.SET_TICKET_FIELDS,
      payload: res
    });
  }).catch(() => {
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        ticketFields: false
      }
    });
    dispatch({
      type: ACTIONS.SET_TICKET_FIELDS,
      payload: []
    });
    notificationHelper('error', __('Failed to fetch ticket fields'), ' ', 5, NO_OP, '');
  });
};
export const setSupportForm = datas => dispatch => {
  const payloadData = datas;
  dispatch({
    type: ACTIONS.SET_SUPPORT_FORMS,
    payload: payloadData
  });
};
export const createNewTicket = (baseUrl, payload, onSuccess, dealerId) => dispatch => {
  const url = "".concat(baseUrl).concat(createTicket);
  dispatch({
    type: ACTIONS.SET_TICKET_LOADER,
    payload: {
      createTicket: true
    }
  });
  return createTicketApi(url, payload, dealerId).then(data => {
    const {
      ticket
    } = data;
    const {
      id
    } = ticket;
    if (typeof onSuccess === 'function') {
      onSuccess(id, ticket);
    }
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        createTicket: false
      }
    });
    notificationHelper('success', __("Ticket #{{ticketId}} has been successfully created", {
      ticketId: id
    }), ' ', 5, NO_OP, '');
    return true;
  }).catch(() => {
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        createTicket: false
      }
    });
    notificationHelper('error', __('Failed to create new ticket'), ' ', 5, NO_OP, '');
    return false;
  });
};
export const fetchTicketCreationFields = baseUrl => dispatch => {
  const url = "".concat(baseUrl).concat(getTicketCreationFields);
  dispatch({
    type: ACTIONS.SET_TICKET_LOADER,
    payload: {
      ticketCreationFields: true
    }
  });
  return fetchTicketCreationFieldsApi(url).then(data => {
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        ticketCreationFields: false
      }
    });
    dispatch({
      type: ACTIONS.SET_TICKET_CREATION_FIELDS,
      payload: data
    });
    dispatch({
      type: ACTIONS.SET_TICKET_DRAWER_API,
      payload: false
    });
  }).catch(() => {
    dispatch({
      type: ACTIONS.SET_TICKET_LOADER,
      payload: {
        ticketCreationFields: false
      }
    });
    dispatch({
      type: ACTIONS.SET_TICKET_DRAWER_API,
      payload: true
    });
    dispatch({
      type: ACTIONS.SET_TICKET_CREATION_FIELDS,
      payload: {}
    });
    notificationHelper('error', __('Failed to fetch Ticket Creation Fields'), ' ', 5, NO_OP, '');
  });
};